import validate from "/vercel/path0/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/nuxt-app/middleware/auth.global.ts";
import guest_45budget_45global from "/vercel/path0/nuxt-app/middleware/guest-budget.global.ts";
import client_45auth from "/vercel/path0/nuxt-app/node_modules/@hebilicious/authjs-nuxt/dist/runtime/middleware/client-auth.mjs";
import manifest_45route_45rule from "/vercel/path0/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  guest_45budget_45global,
  client_45auth,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-seo": () => import("/vercel/path0/nuxt-app/middleware/admin-seo.ts"),
  admin: () => import("/vercel/path0/nuxt-app/middleware/admin.ts"),
  auth: () => import("/vercel/path0/nuxt-app/node_modules/@hebilicious/authjs-nuxt/dist/runtime/middleware/auth.mjs"),
  "guest-only": () => import("/vercel/path0/nuxt-app/node_modules/@hebilicious/authjs-nuxt/dist/runtime/middleware/guest-only.mjs")
}